<template>
  <b-row>
    <b-col lg="12">
      <!-- .name -->
      <validation-observer ref="registerForm" #default="{ invalid }">
        <b-form>
          <b-row>
            <!-- .name -->
            <b-col lg="6">
              <b-form-group
                id="input-group-1"
                :label="$t('master.name')"
                label-for="input-1"
              >
                <validation-provider
                  #default="{ errors }"
                  name="name"
                  vid="name"
                  rules="required"
                >
                  <b-form-input
                    id="input-1"
                    v-model="newItem.name"
                    type="text"
                    :placeholder="$t('master.name')"
                    :state="errors.length > 0 ? false : null"
                  >
                  </b-form-input>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- .instructions -->
            <b-col lg="12">
              <b-form-group
                id="input-group-2"
                :label="$t('master.instructions')"
                label-for="input-2"
              >
                <validation-provider
                  #default="{ errors }"
                  name="instructions"
                  vid="instructions"
                  rules="required"
                >
                  <ckeditor :config="{ contentsLangDirection : 'rtl',versionCheck : false}"  v-model="newItem.instructions"> </ckeditor>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- .minimum_words -->
            <b-col lg="6">
              <b-form-group
                id="input-group-3"
                :label="$t('master.minimum_words')"
                label-for="input-3"
              >
                <validation-provider
                  #default="{ errors }"
                  name="minimum_words"
                  vid="minimum_words"
                  rules="required"
                >
                  <b-form-input
                    id="input-3"
                    v-model="newItem.minimum_words"
                    type="number"
                    :placeholder="$t('master.minimum_words')"
                    :state="errors.length > 0 ? false : null"
                  >
                  </b-form-input>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- .maximum_words -->
            <b-col lg="6">
              <b-form-group
                id="input-group-4"
                :label="$t('master.maximum_words')"
                label-for="input-4"
              >
                <validation-provider
                  #default="{ errors }"
                  name="maximum_words"
                  vid="maximum_words"
                  rules="required"
                >
                  <b-form-input
                    id="input-4"
                    v-model="newItem.maximum_words"
                     type="number"
                    :placeholder="$t('master.maximum_words')"
                    :state="errors.length > 0 ? false : null"
                  >
                  </b-form-input>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- .minimum_references -->
            <b-col lg="6">
              <b-form-group
                id="input-group-5"
                :label="$t('master.minimum_references')"
                label-for="input-5"
              >
                <validation-provider
                  #default="{ errors }"
                  name="minimum_references"
                  vid="minimum_references"
                  rules="required"
                >
                  <b-form-input
                    id="input-5"
                    v-model="newItem.minimum_references"
                     type="number"
                    :placeholder="$t('master.minimum_references')"
                    :state="errors.length > 0 ? false : null"
                  >
                  </b-form-input>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- .maximum_references -->
            <b-col lg="6">
              <b-form-group
                id="input-group-6"
                :label="$t('master.maximum_references')"
                label-for="input-6"
              >
                <validation-provider
                  #default="{ errors }"
                  name="maximum_references"
                  vid="maximum_references"
                  rules="required"
                >
                  <b-form-input
                    id="input-6"
                    v-model="newItem.maximum_references"
                     type="number"
                    :placeholder="$t('master.maximum_references')"
                    :state="errors.length > 0 ? false : null"
                  >
                  </b-form-input>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- .nationalitys -->
            <b-col lg="6">
              <b-form-group
                id="input-group-7"
                :label="$t('master.nationality')"
                label-for="input-7"
              >
                <validation-provider
                  #default="{ errors }"
                  name="nationality"
                  vid="nationality"
                  rules="required"
                >
                  <b-form-select
                    v-model="newItem.nationality_ids"
                    :options="nationalities"
                    text-field="name"
                    value-field="id"
                    :state="errors.length > 0 ? false : null"
                    :placeholder="$t('master.nationality')"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- .minimum_quotation -->
            <b-col lg="6">
              <b-form-group
                id="input-group-8"
                :label="$t('master.minimum_quotation')"
                label-for="input-8"
              >
                <validation-provider
                  #default="{ errors }"
                  name="minimum_quotation"
                  vid="minimum_quotation"
                  rules="required"
                >
                  <b-form-input
                    id="input-8"
                    v-model="newItem.minimum_quotation"
                     type="number"
                    :placeholder="$t('master.minimum_quotation')"
                    :state="errors.length > 0 ? false : null"
                  >
                  </b-form-input>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- .maximum_quotation -->
            <b-col lg="6">
              <b-form-group
                id="input-group-9"
                :label="$t('master.maximum_quotation')"
                label-for="input-9"
              >
                <validation-provider
                  #default="{ errors }"
                  name="maximum_quotation"
                  vid="maximum_quotation"
                  rules="required"
                >
                  <b-form-input
                    id="input-9"
                    v-model="newItem.maximum_quotation"
                     type="number"
                    :placeholder="$t('master.maximum_quotation')"
                    :state="errors.length > 0 ? false : null"
                  >
                  </b-form-input>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
          <hr />
          <b-row>
            <b-col lg="6">
              <b-button
                block
                :disabled="invalid"
                variant="primary"
                @click="submit()"
              >
                <i class="fa fa-plus" /> {{ $t("site.save") }}
              </b-button>
            </b-col>
            <b-col lg="6">
              <b-button block  @click="goToTable()" variant="success">
                <i class="fas fa-ban"></i> {{ $t("site.cancel") }}
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </b-col>
  </b-row>
</template>

<script>
import Controller from "@/Controllers/MasterTypeController";
import config from "@/config/config";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import NationalityController from "@/Controllers/NationalityController";
export default {
  name: "MasterTypeForm",
  props: ["newItem"],
  components: {
    ValidationProvider,
    ValidationObserver,
    required,
  },
  data() {
    return {
      file: {},
      
      nationalitys: 0,
      nationalities: [],
    };
  },
  async created() {
    this.nationalities = await new NationalityController().GetAll();
  },
  methods: {
    async    goToTable() {
      this.$parent.$parent.$children[0].$children[0].$refs.table.refresh();
      this.$parent.$parent.firstTab();
    },
    async submit() {
      let ret = await new Controller().From(this.newItem, "FormData");
      if (ret) {
        this.$parent.$parent.$children[0].$children[0].$refs.table.refresh();
        this.$parent.$parent.firstTab();
      }
    },
  },
};
</script>

